import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProfileService } from '../profile/profile.service';
import { AsYouType, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { SharedService } from "../services/shared.service";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  accountEdit = false;
  accountForm: FormGroup;
	bgTextColor = "#000000";
  disableUpdate: Boolean = true;
  accountDetails: any;
  phoneError: Boolean = false;
  bccMails = []
  bccMailsDefault = false;
  bccEmailErrors = false
  duplicateMails = false;
  tooltip_enabled = false;

  constructor(
    private _fb: FormBuilder,
    private _profileService: ProfileService,
    private _sharedService: SharedService
  ) {

  }

  ngOnInit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");

    this.phoneError = false;
    this.disableUpdate = true;
    this.accountForm = this._fb.group({
      company_name: '',
      name: '',
      phone: '',
      email: '',
      address: '',
      code: ''
    });
    this.bccMails = []
    this.bccMailsDefault = false;
    this.bccEmailErrors = false
    this.duplicateMails = false;
    this.tooltip_enabled = this._sharedService.getTooltipStatus()

    if (this.accountDetails) {
      this.accountForm = this._fb.group({
        company_name: [(this.accountDetails['organization']['account_details']['company_name']) ? this.accountDetails['organization']['account_details']['company_name'] : "", Validators.required],
        name: [(this.accountDetails['organization']['account_details']['name']) ? this.accountDetails['organization']['account_details']['name'] : this.accountDetails['organization']['name'], Validators.required],
        phone: [(this.accountDetails['organization']['account_details']['phone']) ? parsePhoneNumber(this.accountDetails['organization']['account_details']['phone']).formatNational() : "", Validators.required],
        email: [(this.accountDetails['organization']['account_details']['email']) ? this.accountDetails['organization']['account_details']['email'] : "", [Validators.email, Validators.required]],
        address: [(this.accountDetails['organization']['account_details']['address']) ? this.accountDetails['organization']['account_details']['address'] : "", Validators.required],
        code: [(this.accountDetails['organization'] && this.accountDetails['organization']['code']) ? this.accountDetails['organization']['code'] : "", Validators.required]
      });
    }

    this.getOrganizationDetails();
    
  }

  getOrganizationDetails() {
    this._profileService.getOrganization(localStorage.getItem('organization')).subscribe(
      (response) => {
      if (response && response['organization'] && response['organization']['account_details']) {
        this.accountDetails = response;
        let accountDetails = response['organization']['account_details'];
        this.accountForm = this._fb.group({
          company_name: [accountDetails['company_name'], Validators.required],
          name: [accountDetails['name'], Validators.required],
          phone: [ accountDetails['phone'] ? parsePhoneNumber(accountDetails['phone'], "US").formatNational() : '', Validators.required],
          email: [accountDetails['email'], [Validators.email, Validators.required]],
          address: [accountDetails['address'], Validators.required],
          code: [response['organization']['code'], Validators.required]
        });
        if (response['organization']['bcc_emails']) {
          let mails = response['organization']['bcc_emails'];
          mails.forEach(mail => {
            let obj = {
              value: mail,
              valid: true
            }
            this.bccMails.push(obj)
          })
          this.bccMailsDefault = response['organization']['bcc_email_default'] ? true : false;
        }
        if(response['organization'] && response['organization']['tooltip_enabled'] != undefined) {
          if(response['organization']['tooltip_enabled'] == true || response['organization']['tooltip_enabled'] == 'true') {
            this.tooltip_enabled = true
          } else {
            this.tooltip_enabled = false
          }
        } else {
          this.tooltip_enabled = true
        }
      } else if (response && response['organization']) {
        this.accountDetails = response;
        let organization = response['organization'];
        this.accountForm = this._fb.group({
          company_name: [organization['name'], Validators.required],
          name: ["", Validators.required],
          phone: ["", Validators.required],
          email: [(organization['email']) ? organization['email'] : "", [Validators.email, Validators.required]],
          address: ["", Validators.required],
          code: [(organization['code']) ? organization['code'] : "", Validators.required]
        });
        if (organization['bcc_emails']) {
          let mails = organization['bcc_emails'];
          mails.forEach(mail => {
            let obj = {
              value: mail,
              valid: true
            }
            this.bccMails.push(obj)
          })
        }
        this.bccMailsDefault = response['organization']['bcc_email_default'] ? true : false;
        if(response['organization'] && response['organization']['tooltip_enabled'] != undefined) {
          if(response['organization']['tooltip_enabled'] == true || response['organization']['tooltip_enabled'] == 'true') {
            this.tooltip_enabled = true
          } else {
            this.tooltip_enabled = false
          }
        } else {
          this.tooltip_enabled = true
        }
      }
      localStorage.setItem('tooltip_enabled', this.tooltip_enabled.toString())
    },
    err => {
      console.log(err);
      // this.successMsg = false;
    });
  }

  updateData() {

    let accountDetails = {
      name: this.accountForm.controls['name'].value,
      phone: this.accountForm.controls['phone'].value,
      email: this.accountForm.controls['email'].value,
      address: this.accountForm.controls['address'].value,
      bcc_emails: this.bccMails,
      bcc_email_default: this.bccMailsDefault,
      tooltip_enabled: this.tooltip_enabled
    }

    let check = this.checkProperties(accountDetails);
    let bccEmailsValid = this.validateEmails()
    if(this.bccMailsDefault && this.bccMails.length == 0) {
      this.disableUpdate = true;
      return;
    }
    if(!bccEmailsValid) {
      this.duplicateMails = true
      this.disableUpdate = true
      return
    }
    let checkDuplicate = this.checkDuplicateBccMails()
    if(!checkDuplicate) {
      this.disableUpdate = true
      return
    }
    if (!check) {
      this.disableUpdate = true;
      return;
    } else if (this.accountForm.controls['email'].status === "INVALID") {
      this.disableUpdate = true;
      return;
    }
    accountDetails.phone = (parsePhoneNumber(accountDetails.phone, "US")).number;
    const formData: FormData = new FormData();
    formData.append('organizationId', localStorage.getItem('organization'));
    formData.append('account_details', JSON.stringify(accountDetails));

    this._profileService.updateOrganization(formData).subscribe(
      (response) => {
        this.accountEdit = !this.accountEdit;
        this.bccMails = []
        this.disableUpdate = true;
        this.getOrganizationDetails();
        if (response["success"]) {
          this._sharedService.openSnackBar("Acccount updated successfully");
        } else {
          this._sharedService.openSnackBar("Server side error occurred.");
        }
      },
      err => {
        console.log(err);
        this._sharedService.openSnackBar("Server side error occurred.");
        // this.successMsg = false;
      });
  }
  
  cancelUpdate() {
    this.accountEdit = !this.accountEdit;
    this.disableUpdate = true;
    this.ngOnInit();
  }

  checkProperties(obj) {
    for (var key in obj) {
        if (obj[key] === "")
            return false;
    }
    return true;
  }

  onPhoneNumberEdit(input) {
    this.disableUpdate = false;
    this.phoneError = false;
    let phone = new AsYouType('US').input(input);
    if (input.length !== 4) {
      this.accountForm.controls['phone'].setValue(phone);
    }
    let parsedPhone = parsePhoneNumber(this.accountForm.controls['phone'].value, 'US');
    const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
    let nationalNumber = parsedPhone.formatNational();
    let valid = re.test(nationalNumber);
    if (!valid) {
      this.phoneError = true;
      this.disableUpdate = true;
    }
  }

  addBccMail() {
    this.disableUpdate = false;
    this.bccMails.push({value: ""});
  }

  removeBccMail(i) {
    this.disableUpdate = false;
    this.bccMails.splice(i, 1);
    this.duplicateMails = false;
  }

  checkEmailValidity(event, i) {
    this.disableUpdate = false;
    this.checkDuplicateBccMails("emailValidity")
    let email = event.target.value;
    let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if(regex.test(email)) {
      this.bccMails[i].valid = true;
    } else {
      this.bccMails[i].valid = false;
    }
  }
  checkDuplicateBccMails(from?) {
    let uniqueBccMails = [];
    for(const email of this.bccMails) {
      if(email.value !== "" && !uniqueBccMails.includes(email.value)) {
        uniqueBccMails.push(email.value);
      }
    }
    if(uniqueBccMails.length !== this.bccMails.length && from !== "emailValidity") {
      this.duplicateMails = true;
      return false;
    } else {
      this.duplicateMails = false;
      return true;
    }
  }

  validateEmails() {
    let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    for(const mail of this.bccMails) {
      if(!regex.test(mail.value)) {
        return false;
      }
    }
    return true
  }
}
